import { Button, Col, Form, Input, InputNumber, Modal, Row, Space, theme } from "antd"
import React, { useEffect, useState } from "react";
import { requiredItem, TYPE_MODAL } from "../../../constants/constants";

const ModalDataDesign = ({ visible, onCancel, onSave, data, type }) => {
    const [form] = Form.useForm();
    const { token } = theme.useToken();
    const [title, setTitle] = useState('Thêm công việc');

    const formStyle = {
        maxWidth: 'none',
        background: '#fff',
        borderRadius: token.borderRadiusLG,
        paddingTop: 12,
        paddingBottom: 24,
        paddingLeft: 0,
        paddingRight: 0,
    };
    const handleFinish = (values) => {
        if (type === TYPE_MODAL.ADD) {
            onSave(values);
        } else {
            const tempData = {
                ...data,
                ...values
            };
            onSave(tempData);
        }
    };

    useEffect(() => {
        if (type === TYPE_MODAL.EDIT) {
            setTitle('Cập nhật data design');
            form.setFieldsValue({
                sku_code: data?.sku_code || '',
                sku_name: data?.sku_name || '',
                size: data?.size || '',
                color: data?.color || '',
                type: data?.type || '',
                base_cost: data?.base_cost || '',
            });

        } else {
            setTitle('Thêm data design');
            form.resetFields();
            
        }
    }, [data, type]);

    return (
        <Modal
            title={title}
            open={visible}
            onCancel={onCancel}
            width={'70%'}
            footer={null}
        >
            <Form form={form} layout="vertical" name="add-edit-data" style={formStyle} onFinish={handleFinish}>
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item
                            name={'sku_code'}
                            label={<span className={'cus-input-label'}>SKU code</span>}
                            rules={requiredItem}
                        >
                            <Input maxLength={50} />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name={'sku_name'}
                            label={<span className={'cus-input-label'}>Sku name</span>}
                            rules={requiredItem}
                        >
                            <Input maxLength={50} />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name={'size'}
                            label="Size"
                        >
                            <Input maxLength={100} />
                        </Form.Item>
                    </Col>

                </Row>
                <Row gutter={16}>

                    <Col span={8}>
                        <Form.Item
                            name={'color'}
                            label="Color"
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name={'type'}
                            label="Type"
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name={'base_cost'}
                            label={<span className={'cus-input-label'}>Base cost</span>}
                        >
                            <InputNumber
                                className="input-number-cus-ant cus-height-40" 
                                min={0} 
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            />
                        </Form.Item>
                    </Col>
                    
                </Row>
                
                
                <Row gutter={16} justify={'end'}>
                    <Space>
                        <Button onClick={onCancel}>
                            Hủy
                        </Button>
                        <Button type="primary" htmlType="submit">
                            Lưu
                        </Button>
                    </Space>
                </Row>
            </Form>
        </Modal>
    )
}
export default React.memo(ModalDataDesign);

